<template>
  <div class="content">
    <!--    <div class="stem-content"  >-->
    <!--      <div v-if="!value" class="placeholder">请点击{{title}}</div>-->
    <!--      <div v-else v-html="value"></div>-->

    <!--      <bc-file-render :showHandler="false" :fileInfo="fileInfo"></bc-file-render>-->
    <!--    </div>-->

    <bc-view-common :placeholder="`请点击${title}`" @click.native="$refs.editCommon.open(info.content, info.fileInfo)"
                    :content="info.content" :fileInfo="info.fileInfo"
    ></bc-view-common>

    <bc-edit-common :title="title" :isCanBeEmpty="isCanBeEmpty" ref="editCommon" @changeContent="changeContent" @changeFile="changeFile"
    ></bc-edit-common>
  </div>
</template>

<script>

export default {
  name: 'bc-edit-stem',
  components: {},

  props: {
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'title'
    },
    isCanBeEmpty: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          try {
            this.info = JSON.parse(val)
          } catch (err) {
            console.log(err)
          }
        }

      },
      immediate: true
    }
  },
  data() {
    return {
      isShowDialog: false,
      btnLoading: false,

      info: {
        content: '',
        fileInfo: {
          fileUrl: '',
          fileType: '',
          fileSuffix: ''
        }
      },
    }
  },
  methods: {
    changeFile(val) {

    },
    changeContent({ content, file }) {
      this.info.content = content
      this.info.fileInfo = file

      this.$emit('input', JSON.stringify(this.info))
      this.$emit('changeFile', this.info.fileInfo)
    },
    cancel() {
      this.isShowDialog = false
    },
    confirm() {
      this.$emit('input', JSON.stringify(this.info))
      // this.$emit('changeStemFile', this.fileInfo)
      this.isShowDialog = false
    },
    startUpload() {
      this.btnLoading = true
    },
    finishUpload(val) {
      this.btnLoading = false
      this.info.fileInfo = val
      this.$emit('changeFile', this.info.fileInfo)
    },
    removeFile() {
      this.info.fileInfo = {
        fileUrl: '',
        fileType: '',
        fileSuffix: ''
      }
      this.$emit('changeFile', this.info.fileInfo)
    },
    againUpload() {
      console.log(this.$refs.uploadBtn)
      this.$refs.uploadBtn.$el.click()
    }
  }
}
</script>

<style lang="scss" scoped>
//.content {
//  width: 100%;
//
//  .stem-content {
//    width: 100%;
//    box-sizing: border-box;
//    padding: 8px 14px;
//    //min-height: 150px;
//    height: auto;
//    border: 1px solid #E7E7E7;
//    border-radius: 6px;
//    .placeholder {
//      color: #C0C4CC;
//      font-size: 14px;
//      cursor: pointer;
//      user-select: none;
//    }
//  }
//}
</style>
